<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center"><em>to Peter Lewis</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?fe9d9aae